(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js');

'use strict';

const {
  useEffect,
  useMemo,
  useState
} = React;
const {
  getResultMapHandler
} = svs.lyckoplatsen.components.shared_map;
const {
  PinIcon
} = svs.lyckoplatsen.shared_utils.react.components;
const Button = svs.ui.ReactButton;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  correctionStepAtom,
  selectedHighlightedWinGroupAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  mapErrorDialogNoRedirect
} = svs.lyckoplatsen.shared_map.utils;
const MapSingle = _ref => {
  let {
    mapId = 'map-single-pin',
    wagers = null,
    result
  } = _ref;
  const mapHandlerResult = useMemo(() => getResultMapHandler(), []);
  const [highlightedWinGroup, setHighlightedWinGroup] = useAtom(selectedHighlightedWinGroupAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const [showCenterMapButton, setShowCenterMapButton] = useState(false);
  const [showCenterWagersButton, setShowCenterWagersButton] = useState(false);
  const [mapCenter, setMapCenter] = useState(true);
  const [circlesReady, setCirclesReady] = useState(false);
  const winGroupClass = highlightedWinGroup || highlightedWinGroup === 0 ? "lp-wingroup-".concat(highlightedWinGroup) : '';
  const handleCenterMapClick = () => {
    setMapCenter(true);
    mapHandlerResult.centerMap();
    if (highlightedWinGroup !== null) {
      setHighlightedWinGroup(null);
    }
  };
  const handleCenterWagersClick = () => {
    setMapCenter(false);
    mapHandlerResult.centerWagers();
    setHighlightedWinGroup(null);
  };

  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      geoJsonInv: true,
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      showErrorOverlay: false,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      highlightedWinGroup: index => setHighlightedWinGroup(index),
      showCenterMapButton: bool => setShowCenterMapButton(bool),
      showCenterWagersButton: bool => setShowCenterWagersButton(bool),
      resultRendered: () => {
        setCirclesReady(true);
      }
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    return () => mapHandlerResult.removeMap();
  }, [mapHandlerResult, mapId, setHighlightedWinGroup, result]);
  useEffect(() => {
    if (result && correctionStep) {
      const winGroups = result.distribution;
      const winningLocation = result.location;
      mapHandlerResult.showResult({
        winGroups,
        winningLocation
      });
    }
    if (!correctionStep) {
      mapHandlerResult.fitBoundsSweden();
    }
  }, [correctionStep, mapHandlerResult, result]);
  useEffect(() => {
    if (wagers) {
      mapHandlerResult.showWagers(wagers, result);
      return () => mapHandlerResult.removeWagers();
    }
  }, [mapHandlerResult, wagers, result]);


  useEffect(() => {
    if (!mapCenter && highlightedWinGroup !== null && highlightedWinGroup !== 'zoomed') {
      setMapCenter(true);
    }
  }, [highlightedWinGroup, mapCenter]);
  useEffect(() => {
    if (highlightedWinGroup === 0) {
      mapHandlerResult.selectSinglePin();
      mapHandlerResult.moveToWinGroup(0);
      return () => mapHandlerResult.clearSelectedSinglePin();
    }
    if (highlightedWinGroup === 'zoomed') {
      mapHandlerResult.moveToWinGroup(0, true);
    } else if (result && correctionStep && circlesReady && mapCenter) {
      mapHandlerResult.moveToWinGroup(highlightedWinGroup);
    }
  }, [correctionStep, highlightedWinGroup, mapHandlerResult, result, circlesReady, mapCenter]);

  useEffect(() => {
    if (wagers && correctionStep && circlesReady) {
      mapHandlerResult.centerWagers();
    }
  }, [correctionStep, mapHandlerResult, circlesReady, wagers]);
  return React.createElement("div", {
    className: "result-map ".concat(winGroupClass, " ").concat(wagers ? 'has-wagers' : '')
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), correctionStep !== 0 && React.createElement(Button, {
    disabled: !showCenterMapButton,
    className: "lp-btn-center-map ".concat(showCenterMapButton ? '' : 'disable'),
    onClick: handleCenterMapClick
  }, React.createElement(PinIcon, {
    color: "green"
  })), wagers && React.createElement(Button, {
    disabled: !showCenterWagersButton,
    className: "lp-btn-center-wagers ".concat(showCenterWagersButton ? '' : 'disable'),
    onClick: handleCenterWagersClick
  }, React.createElement(PinIcon, {
    color: "red"
  })));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapSingle
});

 })(window);